
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { LanguagesEnum, PrivacyPolicyResponse } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { SystemApi } from "../../autogen";

@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class PrivacyPolicyForm extends FormMixin {
  validationSchema!: yup.AnyObjectSchema;
  @Prop({ type: Object }) privacyPolicy: PrivacyPolicyResponse = {};
  @Prop({ type: String }) lang: keyof typeof LanguagesEnum = "ja";
  formName = "受検結果の閲覧範囲";

  get language() {
    return LanguagesEnum[this.lang];
  }
  beforeCreate() {
    this.validationSchema = yup.object({
      policy: yup.string().required(this.$t("input_required", { field: "受検結果の閲覧範囲" })),
      contactName: yup.string().required(this.$t("input_required", { field: "問い合わせ先" })),
      contactEmail: yup.string().required(this.$t("input_required", { field: "問い合わせ先メールアドレス" }))
    });
  }
  async onBeforeSubmit(privacyPolicy: PrivacyPolicyResponse) {
    this.formName = `閲覧範囲（${this.language}）`;
    await this.onSubmit(async () => {
      await new SystemApi().updatePrivacyPolicy({
        privacyPolicyRequest: {
          language: this.lang as string,
          policy: privacyPolicy.policy!,
          contactName: privacyPolicy.contactName!,
          contactEmail: privacyPolicy.contactEmail!
        }
      });
      this.$emit("submit");
    });
  }
}
